import React from "react";
import "./HouseholdJunkRemoval.css";
import { FiTrash } from "react-icons/fi";
import junk from "../../Assests/service1.webp";

const HouseholdJunkRemoval = () => {
  return (
    <section className="junk-removal-section">
      <div className="junk-removal-container">
        {/* Content Column */}
        <div className="junk-removal-content">
          <div className="content-header">
            <div className="service-icons">
              <FiTrash size={32} />
            </div>
            <h1 className="service-title">
              <span className="title-accent">Household</span> Junk Removal
            </h1>
          </div>

          <p className="service-description">
            Hoarder cleanouts require patience, compassion, and the right team.
            We specialize in clearing homes overwhelmed with clutter and belongings,
            always working with professionalism and respect—never judgment.
            Our crew handles trash, furniture, appliances, and more, ensuring each
            space is left neat and ready for its next use.
          </p>

          <p className="service-description">
            Services cover entire homes, garages, attics, and basements with quick
            scheduling for a stress-free experience. We take clutter, furniture,
            clothing, appliances, boxed items, and yard debris—recycling or donating
            whenever possible for safe, responsible disposal.
          </p>

          <div className="cta-group">
            <a
              href="https://app.squareup.com/appointments/book/41vplmwf0luh01/LTHMTFD90TMRT/start"
              className="primary-cta1"
              target="_blank"
              rel="noopener noreferrer"
            >
              Schedule Your Pickup
              <span className="cta-arrow">→</span>
            </a>
          </div>
        </div>

        {/* Image Column */}
        <div className="junk-removal-image">
          <img
            src={junk}
            alt="Professional junk removal team clearing household items"
            className="main-image"
            loading="lazy"
          />
        </div>
      </div>
    </section>
  );
};

export default HouseholdJunkRemoval;
